const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/defs/router.ts';
export const PATH_DASHBOARD = '/app/dashboard';
export const PATH_ECHECKIN = '/app/echeckin';
export const PATH_APPOINTMENTS = '/app/appointments';
export const PATH_APPOINTMENT_BOOKING = '/app/appointment/booking';
export const PATH_APPOINTMENT_BOOKING_CONFIRMATION = '/app/appointment/:termnr/bookingConfirmation';
export const PATH_APPOINTMENT_RESCHEDULE = '/app/appointment/:termnr/reschedule';
export const PATH_APPOINTMENT_RESCHEDULE_CONFIRMATION = '/app/appointment/:termnr/rescheduleConfirmation';
export const PATH_APPOINTMENT = '/app/appointment/:termnr';
export const PATH_MEDIS = '/app/medis';
export const PATH_REPORTS = '/app/reports';
export const PATH_INVOICES = '/app/invoices';
export const PATH_APPOINTMENT_SUBLIMD_FRAME = '/app/sublimd/:termnr';
